import React from 'react';
import './blog-post.css';

import candle1 from './pictures/candle1.png';
import candle2 from './pictures/candle2.png';
import candle3 from './pictures/candle3.png';
import candle4 from './pictures/candle4.png';
import candle5 from './pictures/candle5.png';
import candle6 from './pictures/candle6.png';
import candle7 from './pictures/candle7.png';
import candle8 from './pictures/candle8.png';

//import reportWebVitals from './reportWebVitals';

const Candle = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Winter MM2: Candle Painting and Charcuterie Boards Recap</h2>
                    <p class="site-post-meta">February 9th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    On February 9th, WiC members gathered for a cozy Candle Painting & Charcuterie Board night. 
                    It was an evening filled with creativity and relaxation as members designed their own candles 
                    and assembled delicious personal charcuterie boards from a variety of snacks. 
                    The vibes were enhanced by the one and only Laufey, creating a place for everyone to unwind, 
                    socialize, and explore their artistic talents. We hope that this event provided a wonderful opportunity 
                    for members to connect and enjoy a break from their busy schedules.

                    <br></br>
                     
                    </p>
                    <img src={candle1} alt=""/>
                    <img src={candle2} alt=""/>
                    <img src={candle3} alt=""/>
                    <img src={candle4} alt=""/>
                    <img src={candle5} alt=""/>
                    <img src={candle6} alt=""/>
                    <img src={candle7} alt=""/>
                    <img src={candle8} alt=""/>
 
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Candle;

